import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import { ORM } from 'utility-ts-orm';
import { PollAnswerDataStore } from '../datastore/poll_answer_datastore';
import { ScheduledPollDatastore } from './../datastore/scheduled_poll_datastore';

angular
  .module('capability-ng-poll')
  .factory(
    'loadScheduledPollsCommand',
    function loadScheduledPollsCommandDefinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      ngScheduledPollDatastore: ScheduledPollDatastore,
      defineCommand: any
    ): void {
      return defineCommand(
        'loadScheduledPollsCommand',
        function loadScheduledPollsCommand(deferred: ng.IDeferred<any>): void {
          $http
            .get('/poll/scheduled/')
            .then(({ data }: any): void => {
              ngScheduledPollDatastore.write(data);
              deferred.resolve(ORM.run(ngScheduledPollDatastore));
            })
            .catch((err: ng.IHttpPromiseCallbackArg<any>) => {
              deferred.reject(err);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/load_scheduled_polls_command.ts